
import { WorldCountry } from './types';
import { saudiArabiaData } from './saudiArabia';
import { unitedArabEmiratesData } from './unitedArabEmirates';
import { israelData } from './israel';
import { turkeyData } from './turkey';
import { iranData } from './iran';
import { iraqData } from './iraq';
import { jordanData } from './jordan';
import { lebanonData } from './lebanon';
import { middleEastExpansion } from './middleEast/middleEastExpansion';
import { turkeyExpansion3 } from './middleEast/turkeyExpansion3';

export const middleEastCountries = [
  saudiArabiaData,
  unitedArabEmiratesData,
  israelData,
  turkeyData,
  iranData,
  iraqData,
  jordanData,
  lebanonData,
  ...middleEastExpansion, // Incluye Turquía expandida original
  ...turkeyExpansion3 // Incluye Turquía expandida Fase 7
];
